import { createRequestTypes } from '../utils';

export const FETCH_RAWMAT_ACTIONS = createRequestTypes('rawMatAction/FETCH_RAWMAT_ACTIONS');
